import styled from "styled-components";

export const Links = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_8};
  width: 100%;
  margin: 0;
  padding: 0;
`;

export const Link = styled.li`
  list-style: none;
`;
